import { useSignOutMutation } from "@/modules/auth/services";
import { setIsAuth } from "@/modules/auth/state";
import { AppPaths, Storage } from "@/shared/common/enums";
import { SignOutIcon } from "@/shared/components/SvgIcons";
import { clearUserFromStorage, getFromLocalStorage, getNameChars, } from "@/shared/helpers";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { setPendingSignOut } from "@/shared/state/common";
import { stopImmediatePropagation } from "@/shared/utils";
import { Avatar } from "@ab.uitools/ui-library/components/Avatar";
import { Menu } from "@ab.uitools/ui-library/components/Menu";
import { Positions } from "@ab.uitools/ui-library/components/Tooltip/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const UserMenu = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [signOut] = useSignOutMutation();
  const hasUnsavedChanges = useAppSelector((state) => state.common.hasUnsavedChanges);

  const [open, setOpen] = useState<boolean>(false);
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const fullName = getFromLocalStorage(Storage.FullName);

  const closeUserMenu = () => {
    setOpen(false);
  };

  const handleSignOut = () => {
    if (hasUnsavedChanges) {
      dispatch(setPendingSignOut(true));
      return;
    }

    signOut()
      .unwrap()
      .then(() => {
        clearUserFromStorage();
        dispatch(setIsAuth(false));
        navigate(AppPaths.Login);
      });
  };

  const menuItems = [{
    label: t("general.signOut"),
    value: "sign_out",
    handler: () => handleSignOut(),
    iconProps: {
      Component: SignOutIcon,
    }
  }];

  return (
    <div ref={setRef} className="user-menu">
      <div
        onMouseDown={stopImmediatePropagation}
        className="flexbox align-items--center"
        onClick={() => setOpen(!open)}
      >
        <Avatar size="xsmall" initials={fullName ? getNameChars(fullName) : ""}/>
      </div>
      <Menu
        position={Positions.BOTTOM_LEFT}
        onClose={closeUserMenu}
        isOpen={open}
        parentRef={ref}
        menuItems={menuItems}
      />
    </div>
  );
};
